"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _material = require("@mui/material");

var _utilities = require("../../utilities");

var _Icon = require("../Icon");

var _ReadOnlyField = require("../ReadOnlyField");

var _theme = require("../../theme");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["aria-label", "InputProps", "InputLabelProps", "label", "maxLength", "onChange", "onKeyDown", "value", "id", "inputProps", "ReadOnlyFieldProps", "error", "disabled", "readOnly", "fullWidth", "required", "type", "margin"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledMuiTextField = (0, _material.styled)(_material.TextField)(function (_ref) {
  var _ref2;

  var theme = _ref.theme;
  return _ref2 = {}, (0, _defineProperty2.default)(_ref2, "& .".concat(_utilities.classes.components.MuiInputBase.multiline), {
    padding: theme.spacing(0)
  }), (0, _defineProperty2.default)(_ref2, "& .".concat(_utilities.classes.components.MuiInputBase.input, ".").concat(_utilities.classes.states.MuiDisabled), {
    color: "#6D6D6D",
    WebkitTextFillColor: "#6D6D6D"
  }), (0, _defineProperty2.default)(_ref2, "& .".concat(_utilities.classes.components.MuiInputBase.input, ".").concat(_utilities.classes.states.MuiDisabled, "::placeholder"), {
    opacity: 1
  }), _ref2;
});

var TextField = function TextField(_ref3) {
  var ariaLabel = _ref3["aria-label"],
      InputProps = _ref3.InputProps,
      InputLabelProps = _ref3.InputLabelProps,
      label = _ref3.label,
      maxLength = _ref3.maxLength,
      onChange = _ref3.onChange,
      onKeyDown = _ref3.onKeyDown,
      value = _ref3.value,
      id = _ref3.id,
      inputProps = _ref3.inputProps,
      ReadOnlyFieldProps = _ref3.ReadOnlyFieldProps,
      _ref3$error = _ref3.error,
      error = _ref3$error === void 0 ? false : _ref3$error,
      _ref3$disabled = _ref3.disabled,
      disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
      _ref3$readOnly = _ref3.readOnly,
      readOnly = _ref3$readOnly === void 0 ? false : _ref3$readOnly,
      _ref3$fullWidth = _ref3.fullWidth,
      fullWidth = _ref3$fullWidth === void 0 ? false : _ref3$fullWidth,
      _ref3$required = _ref3.required,
      required = _ref3$required === void 0 ? false : _ref3$required,
      _ref3$type = _ref3.type,
      type = _ref3$type === void 0 ? "text" : _ref3$type,
      _ref3$margin = _ref3.margin,
      margin = _ref3$margin === void 0 ? "none" : _ref3$margin,
      rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  var staticId = (0, _react.useMemo)(function () {
    return id || (0, _utilities.generateId)();
  }, [id]);
  var startAdornment = type === "search" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.InputAdornment, {
    position: "start",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
      ml: 1,
      px: 1,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        color: _theme.palette.brand.grey.stone,
        iconName: "search",
        size: "small"
      })
    })
  }) : null;
  var endAdornment = error ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.InputAdornment, {
    position: "end",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
      mr: 1,
      px: 1,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        iconName: "exclamation-triangle",
        size: "small"
      })
    })
  }) : null;
  var onChangeHandler = (0, _react.useCallback)(function (event) {
    // For `number` input only, strip `e` character when pasting value from the clipboard.
    // `input.value` not falsy check is needed here as React fires `onChange` event with
    // an empty value for `-` and `+` symbols which causes losing value.
    if (type === "number" && event.target.value) {
      event.target.value = event.target.value.replace(/e/gi, "");
    } // Invoke props `onChange` function with event.


    typeof onChange === "function" && onChange(event);
  }, [onChange, type]);
  var onKeyDownHandler = (0, _react.useCallback)(function (event) {
    // For `number` input only, prevent `e` character from being added.
    if (type === "number" && event.keyCode === 69) {
      event.preventDefault();
    } // Invoke props `onChange` function with event.


    typeof onKeyDown === "function" && onKeyDown(event);
  }, [onKeyDown, type]);

  if (readOnly) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ReadOnlyField.ReadOnlyField, _objectSpread({
      content: value,
      label: label
    }, ReadOnlyFieldProps));
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledMuiTextField, _objectSpread(_objectSpread({
    InputLabelProps: _objectSpread(_objectSpread({}, InputLabelProps), {}, {
      shrink: true
    }),
    InputProps: _objectSpread({
      endAdornment: endAdornment,
      startAdornment: startAdornment
    }, InputProps),
    disabled: disabled,
    error: error,
    id: staticId,
    inputProps: _objectSpread({
      "aria-label": ariaLabel,
      maxLength: maxLength
    }, inputProps),
    label: label,
    margin: margin,
    onChange: onChangeHandler,
    onKeyDown: onKeyDownHandler,
    required: required,
    type: type,
    value: value
  }, rest), {}, {
    fullWidth: fullWidth
  }));
};

var _default = TextField;
exports.default = _default;